import styled from "styled-components";

const StyledAddressContainer = styled.section`
  flex: 1;
  height: auto;
  border: 1px solid #d8d8d8;
  border-radius: 10px;
  margin: 0px;
  padding: 20px;
  h1 {
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
    margin: 0px 0px 10px 0px;
    padding: 0px;
    color: #000000;
  }
  p {
    font-size: 14px;
    margin: 0px 0px 10px 0px;
    padding: 0px;
    color: #000000;
  }
`;

const StyledActionsContainer = styled.section`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
`;

const StyledButtonAsLink = styled.button`
  font-size: 14px;
  font-weight: normal;
  padding: 0px;
  margin: 0px;
  background-color: transparent;
  border: 0px;
  outline: 0px;
  cursor: pointer;
  transition: color 0.5s ease;
  &:hover {
    transition: color 0.5s ease;
  }
  &.edit {
    color: #0095ff;
    &:hover {
      color: #0079cf;
    }
  }
  &.delete {
    color: red;
    &:hover {
      color: #b00000;
    }
  }
`;

const AddressCard = ({
  id,
  pocName,
  pocNumber,
  addressLine1,
  addressLine2,
  city,
  state,
  country,
  pincode,
  location,
  onClickEdit,
  onClickDelete,
}) => {
  return (
    <StyledAddressContainer>
      <h1>{pocName}</h1>
      <p>
        {addressLine1} {addressLine2} {city}, {state}, {country}, {pincode}
      </p>
      <p>{pocNumber}</p>
      <StyledActionsContainer>
        <StyledButtonAsLink onClick={() => onClickEdit(id)} className="edit">
          Edit
        </StyledButtonAsLink>
        <StyledButtonAsLink
          onClick={() => onClickDelete(id)}
          className="delete"
        >
          Delete
        </StyledButtonAsLink>
      </StyledActionsContainer>
    </StyledAddressContainer>
  );
};

export default AddressCard;
